"use strict";

angular.module("vendor")
.factory("ImportDocument", function($resource, $http, gettextCatalog, FlashBag, appConfig) {
    var importLogListing = $resource(appConfig.API_SERVER + "/import/vendor/documents/", {}, {
        query: {
            method: "GET",
            isArray: false
        }
    });

    function getStatusLocalized() {
        return {
            success: gettextCatalog.getString("Success"),
            error: gettextCatalog.getString("Error"),
            completed_with_errors: gettextCatalog.getString("Completed With Errors")
        }
    }

    function getStatusFilter() {
        var values = [];
        var filterValues = getStatusLocalized();

        angular.forEach(filterValues, function(value, key) {
            values.push({
                Value: key,
                Name: value
            });
        });

        return values;
    }

    function getDocumentTypeLocalized() {
        return {
            partnership: gettextCatalog.getString("Partnership", null, "Import document type"),
            delivery_rule: gettextCatalog.getString("Delivery Rule", null, "Import document type"),
            product: gettextCatalog.getString("Product", null, "Import document type"),
            product_variant: gettextCatalog.getString("Product Variants", null, "Import document type"),
            preferred: gettextCatalog.getString("Preferred", null, "Import document type"),
            promotions: gettextCatalog.getString("Promotion", null, "Import document type"),
            catalog: gettextCatalog.getString("Catalog", null, "Import document type"),
            catalog_entries: gettextCatalog.getString("Catalog Entry", null, "Import document type"),
            catalog_entry_variant: gettextCatalog.getString("Catalog Entry Variants (prices)", null, "Import document type"),
            catalog_sharing: gettextCatalog.getString("Catalog Sharing", null, "Import document type"),
            invoice: gettextCatalog.getString("Invoice", null, "Import document type"),
            goods_receipt: gettextCatalog.getString("Goods Receipt", null, "Import document type"),
            goods_transfer: gettextCatalog.getString("Goods Transfer", null, "Import document type"),
        }
    }

    function getDocumentTypeFilter() {
        var values = [];
        var filterValues = getDocumentTypeLocalized();

        angular.forEach(filterValues, function(value, key) {
            values.push({
                Value: key,
                Name: value
            });
        });

        return values;
    }

    return {
        query: function(search, page, filters) {
            var params = {
                search: search,
                page: page,
            };
            params = angular.extend(params, filters);
            return importLogListing.query(params,
                function(data) {
                },
                function errorCallback(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        reProcessErrors: function(documentId) {
            return $http({
                method: "POST",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/import/vendor/documents/re-process-errors/",
                data: {
                    id: documentId
                }
            });
        },
        getStatusFilter: getStatusFilter,
        getStatusLocalized: getStatusLocalized,
        getDocumentTypeFilter: getDocumentTypeFilter,
        getDocumentTypeLocalized: getDocumentTypeLocalized
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/import/import-document.factory.js
// module id = 1011
// module chunks = 0